<template>
	<v-container fluid>
		<div v-if="!codigoContrato" class="d-flex flex-wrap py-2">
			<v-btn class="ma-1" color="primary" small @click="getContratos">
				<v-icon left>mdi-reload</v-icon>Recargar
			</v-btn>
			<v-dialog max-width="1000">
				<template v-slot:activator="{ on, attrs }">
					<v-btn v-on="on" v-bind="attrs" class="ma-1" color="primary" small>
						<v-icon left>mdi-chart-bar</v-icon>Contratos por mes
					</v-btn>
				</template>
				<v-card class="pa-2">
					<bar-chart />
				</v-card>
			</v-dialog>
			<v-btn class="ma-1" color="primary" small @click.stop="getContratosProximaRenovacion">
				<v-icon left>mdi-reload</v-icon>próxima renovación
			</v-btn>

			<v-switch
				class="mt-0 ml-1 align-self-center"
				label="Ver Anulados"
				hide-details
				v-model="verAnulados"
			></v-switch>

			<v-spacer />
			<v-btn
				v-if="$root.acceso('CAMBIAR_ESTADOS_CONTRATO')"
				@click="cambiarEstado = true"
				text
				color="primary"
				class="mr-1"
				:disabled="selected.length == 0"
			>Cambiar estado</v-btn>
			<download-csv
				:data="selected"
				:name="`datos_contratos_${new Date().getTime()}.csv`"
				delimiter=";"
				ref="descargarBtn"
				v-if="$root.acceso('DESCARGAR_CSV_CONTRATOS')"
			>
				<v-btn text class="ma-1" color="primary" small :disabled="selected.length == 0">
					<v-icon left>mdi-download</v-icon>Descargar seleccionados
				</v-btn>
			</download-csv>
		</div>
		<div v-if="!codigoContrato && $root.acceso('CREAR_CONTRATO')" class="pa-0">
			<v-card-subtitle class="pa-0">
				Los contratos nuevos se cargan en
				<router-link
					style="color: var(--v-secondary-base); text-decoration: none"
					to="/borradores"
				>borradores</router-link>
			</v-card-subtitle>
		</div>
		<v-card>
			<v-data-table
				fixed-header
				:items="contratosFiltrados"
				:headers="contratosHeader"
				show-select
				item-key="CodigoContrato"
				v-model="selected"
				:single-select="false"
				:calculate-widths="true"
				:search="search"
				:loading="loading"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 25, 50],
				}"
				checkbox-color="secondary"
			>
				<template v-slot:body.prepend="{ headers }">
					<table-filters :headers="headers" :items="contratosFiltrados" v-model="inlineFilters"></table-filters>
				</template>

				<template v-slot:item.Situacion="{ item }">
					<status-chip
						:value="Number(item.incidencia) && item.estado != 'Anulado' ? 'Incidencia' : item.Situacion"
					/>
				</template>

				<template v-slot:item.acciones="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								:to="`/facturas?codigoContrato=${item.CodigoContrato}`"
								color="secondary"
								icon
							>
								<v-icon>mdi-paperclip</v-icon>
							</v-btn>
						</template>
						<span>Ver facturas</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$root.acceso('INICIAR_FIRMAS_CONTRATO')">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								color="secondary"
								icon
								@click="verEvidenciaFirma(item.CodigoContrato)"
								:disabled="
									!!gettingCert ||
									['Pendiente de Firma', 'Anulado'].includes(item.Situacion)
								"
								:loading="
									gettingCert == item.CodigoContrato ||
									['Generando certificado'].includes(item.Situacion)
								"
							>
								<v-icon>mdi-file-certificate-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver certificado firma</span>
					</v-tooltip>
					<template v-if="$root.acceso('INICIAR_FIRMAS_CONTRATO')">
						<v-tooltip
							bottom
							v-if="
								!Boolean(Number(item.firmaSMS)) &&
								!Boolean(Number(item.firmaEmail))
							"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn disabled icon v-on="on" v-bind="attrs">
									<v-icon color="secondary">mdi-file-document-edit-outline</v-icon>
								</v-btn>
							</template>
							<span>Firmado manualmente</span>
						</v-tooltip>
						<v-tooltip bottom v-else-if="Boolean(Number(item.firmaSMS))">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									color="secondary"
									icon
									@click="reenviarFirmaSMS(item)"
									:disabled="
										!!reenviandoSMS ||
										!['Pendiente de Firma', 'Firma no válida'].includes(
											item.Situacion
										)
									"
									:loading="reenviandoSMS == item.CodigoContrato"
								>
									<v-icon>mdi-message-processing-outline</v-icon>
								</v-btn>
							</template>
							<span>Reenviar firma SMS</span>
						</v-tooltip>
						<v-tooltip bottom v-else-if="Boolean(Number(item.firmaEmail))">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									color="secondary"
									icon
									@click="recordatorioEmail(item)"
									:disabled="
										!!reenviandoSMS ||
										!['Pendiente de Firma', 'Firma no válida'].includes(
											item.Situacion
										)
									"
									:loading="reenviandoSMS == item.CodigoContrato"
								>
									<v-icon>mdi-email-edit-outline</v-icon>
								</v-btn>
							</template>
							<span>Enviar recordatorio firma Email</span>
						</v-tooltip>
					</template>
					<v-menu offset-x v-if="$root.acceso('INICIAR_FIRMAS_CONTRATO')">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								color="secondary"
								icon
								:loading="reenviandoSMS == item.CodigoContrato"
							>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>
						<v-list dense>
							<v-list-item
								:disabled="
									Boolean(Number(item.firmaSMS)) ||
									Boolean(Number(item.firmaEmail))
								"
								@click.stop="reenviarFirmaSMS(item)"
							>
								<v-list-item-icon>
									<v-icon>mdi-message-processing-outline</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>Iniciar firma SMS</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item
								:disabled="
									Boolean(Number(item.firmaSMS)) ||
									Boolean(Number(item.firmaEmail))
								"
								@click.stop="enviarFirmaEmail(item)"
							>
								<v-list-item-icon>
									<v-icon>mdi-email-edit-outline</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>Iniciar firma email</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-tooltip bottom v-if="false && $root.acceso('DEV')">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								color="secondary"
								icon
								@click="generarPDF(item)"
								:disabled="generandoPDF != null"
								:loading="generandoPDF == item.CodigoContrato"
							>
								<v-icon>mdi-printer</v-icon>
							</v-btn>
						</template>
						<span>Generar PDF</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$root.acceso('VER_INCIDENCIAS')">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								color="error"
								icon
								:to="`/incidencias?idContrato=${item.IdContrato}&codigoContrato=${item.CodigoContrato}`"
							>
								<v-badge
									bordered
									color="error darken-2"
									overlap
									:value="Boolean(Number(item.incidencias))"
									:content="item.incidencias"
								>
									<v-icon>mdi-alert-circle</v-icon>
								</v-badge>
							</v-btn>
						</template>
						<span>
							Ver{{
								$store.getters.getPermisos.CREAR_INCIDENCIAS & $store.getters.getDecodedJwtEmpresa.permisos_b ? " / Crear" : ""
							}}
							Incidencias
						</span>
					</v-tooltip>
					<template v-if="$root.acceso('VER_FACTURAS_COLABORADORES')">
						<v-tooltip v-if="item.facturado === '0'" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									color="secondary"
									:disabled="!['Activado', 'Baja'].includes(item.Situacion)"
									icon
								>
									<v-icon>mdi-account-cash-outline</v-icon>
								</v-btn>
							</template>
							<span>Facturado manualmente</span>
						</v-tooltip>
						<v-tooltip v-else-if="item.facturado === '-1' || item.comisionable === '0'" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									:disabled="!['Activado', 'Baja'].includes(item.Situacion)"
									icon
								>
									<v-icon>mdi-cash-remove</v-icon>
								</v-btn>
							</template>
							<span>No autofacturable</span>
						</v-tooltip>
						<v-tooltip v-else-if="item.facturado != null" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									color="secondary"
									:disabled="!['Activado', 'Baja'].includes(item.Situacion)"
									icon
									:to="`/autofacturas?idFactura=${item.facturado}`"
								>
									<v-icon>mdi-currency-eur</v-icon>
								</v-btn>
							</template>
							<span>Facturado</span>
						</v-tooltip>
						<v-tooltip v-else-if="item.facturado === null && item.comisionable === '1'" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-on="on"
									v-bind="attrs"
									color="secondary"
									:disabled="!['Activado', 'Baja'].includes(item.Situacion)"
									icon
									to="/autofacturar"
								>
									<v-icon>mdi-cash-register</v-icon>
								</v-btn>
							</template>
							<span>Sin facturar</span>
						</v-tooltip>
					</template>
				</template>

				<template v-slot:item.comision="{ item }">
					<v-chip
						:class="`${item.comision < 0 ? 'error' : 'secondary'}--text v-chip--active`"
						small
						pill
						outlined
						:color="item.comision < 0 ? 'error' : 'secondary'"
						v-if="item.comisionable === '1'"
					>{{ parseFloat(item.comision).toFixed(2) }} €</v-chip>
				</template>

				<template v-slot:item.CodigoContrato="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_contrato?codigoContrato=${item.CodigoContrato}&idContrato=${item.IdContrato}`"
								color="secondary"
								text
							>{{ item.CodigoContrato }}</v-btn>
						</template>
						<span>Detalles del contrato</span>
					</v-tooltip>
				</template>

				<template v-slot:item.Identificador="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_cliente?idCliente=${item.IdCliente}`"
								color="secondary"
								text
							>{{ item.Identificador }}</v-btn>
						</template>
						<span>Detalles del cliente</span>
					</v-tooltip>
				</template>

				<template v-slot:item.CodigoCUPS="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_cups?cups=${item.CodigoCUPS}`"
								color="secondary"
								text
							>{{ item.CodigoCUPS }}</v-btn>
						</template>
						<span>Detalles del CUPS</span>
					</v-tooltip>
				</template>

				<template v-slot:item.FechaAlta="{ item }">
					<span v-text="parseDate(item.FechaAlta)"></span>
				</template>
				<template v-slot:item.FechaBaja="{ item }">
					<span v-text="parseDate(item.FechaBaja)"></span>
				</template>
				<template v-slot:item.FechaContrato="{ item }">
					<span v-text="parseDate(item.FechaContrato)"></span>
				</template>

				<template v-slot:item.Tarifa="{ item }">
					<v-chip v-show="item.Tarifa" label small v-text="item.Tarifa" />
				</template>

				<template v-slot:item.TarifaGrupo="{ item }">
					<span
						v-if="item.TarifaGrupo && !(item.TarifaGrupo).includes('FLEXIBLE')"
						v-text="item.TarifaGrupo.split(' ($')[0]"
					/>
					<v-tooltip v-else bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								@click="copiarTexto(item.TarifaGrupo)"
								small
								text
								color="secondary"
								v-on="on"
								v-bind="attrs"
								class="pa-0"
							>Flexible</v-btn>
						</template>
						<span v-text="item.TarifaGrupo" />
					</v-tooltip>
				</template>

				<template v-slot:item.DiasSinFacturar="{ item }">
					<v-chip
						class="mb-0 pa-2"
						small
						dense
						label
						:color="comprobarDiasFacturacion(item.DiasSinFacturar, item.Situacion).color"
					>{{ comprobarDiasFacturacion(item.DiasSinFacturar, item.Situacion).texto }}</v-chip>
				</template>

				<template v-slot:footer.prepend>
					<v-chip
						:color="
							$store.getters.getEntorno == 'Luz'
								? 'amber darken-2'
								: 'deep-orange'
						"
						outlined
					>
						<v-icon left>
							{{
								$store.getters.getEntorno == "Luz"
									? "mdi-lightning-bolt"
									: "mdi-fire"
							}}
						</v-icon>
						<span>{{ $store.getters.getEntorno }}</span>
					</v-chip>
				</template>
			</v-data-table>
		</v-card>

		<div
			v-if="$root.acceso('DESCARGAR_CSV_CONTRATOS') && !codigoContrato"
			class="d-flex flex-wrap mt-4"
			style="gap: 16px"
		>
			<v-btn text color="primary" @click="exportarTodos">
				<v-icon left>mdi-download</v-icon>Exportar todos
			</v-btn>
		</div>

		<v-dialog
			max-width="1200px"
			width="100%"
			@input="(v) => (v ? null : (documentacionModal = null))"
			:value="documentacionModal"
		>
			<v-card color>
				<v-toolbar color="primary">
					<v-toolbar-title class="white--text">No se ha firmado electrónicamente</v-toolbar-title>
					<v-spacer />
					<v-btn icon color="white" @click="documentacionModal = null">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<documentacion-contrato
					:key="documentacionModal + Math.random()"
					:codigoContrato="documentacionModal"
					@close="documentacionModal = false"
				/>
			</v-card>
		</v-dialog>

		<v-dialog persistent max-width="600px" width="100%" v-model="cambiarEstado">
			<cambiar-estado
				:key="cambiarEstado"
				@reload="getContratos"
				:contratos="selected.map((c) => c.CodigoContrato)"
				@close="cambiarEstado = false"
			/>
		</v-dialog>

		<portal-target name="filter-btn" />
	</v-container>
</template>

<script>
// import {axios} from '@/main.js';
import {
	processToken,
	getSituacionIcon,
	perColumnFilter,
	parseDate,
	downloadFile,
} from "@/utils/index.js";

export default {
	components: {
		BarChart: () => import("@/components/BarChart.vue"),
		TableFilters: () => import("@/components/TableFilters.vue"),
		StatusChip: () => import("@/components/StatusChip.vue"),
		CambiarEstado: () => import("@/components/CambiarEstado.vue"),
		DocumentacionContrato: () =>
			import("@/components/DocumentacionContrato.vue"),
	},
	props: {
		codigoContrato: Number | String,
	},
	data() {
		return {
			debounce: true,
			loading: true,
			verAnulados: false,
			page: 2,
			selected: [],
			search: null,
			development: process.env.NODE_ENV == "development",
			contratos: [],
			cambiarEstado: false,
			contratosHeader: [
				{ text: "Situacion", value: "Situacion", dataType: "select" },
				{
					text: "Acciones",
					value: "acciones",
					filterable: false,
					sortable: false,
				},
				// { text: "EMAIL", value: "firmaEmail" },
				// { text: "SMS", value: "firmaSMS" },
				{ text: "Comisión", value: "comision", acceso: 'VER_FACTURAS_COLABORADORES' },
				{ text: "Canal", value: "Canal", cellClass: "pa-2 text-no-wrap font-weight-medium" },
				{ text: "Subagente", value: "SubAgente" },
				{ text: "Grupo Tarifa", value: "TarifaGrupo" },
				{ text: "Contrato", value: "CodigoContrato" },
				{ text: "DNI/NIE", value: "Identificador" },
				{ text: "Nombre", value: "Denominacion" },
				{ text: "CUPS", value: "CodigoCUPS" },
				{ text: "Direccion Cups", value: "DireccionCUPS" },
				// { text: "Ciudad Cups", value: "CiudadSuministro" },
				{ text: "Fecha Alta", value: "FechaAlta", dataType: "date" },
				{ text: "Fecha Baja", value: "FechaBaja", dataType: "date" },
				{ text: "Fecha Contrato", value: "FechaContrato", dataType: "date" },
				{ text: "Tarifa", value: "Tarifa", dataType: "select" },
				{ text: "Consumo Anual", value: "ConsumoEstimado", align: "end" },
				{ text: "P1", value: "P1", align: "end" },
				{ text: "P2", value: "P2", align: "end" },
				{ text: "P3", value: "P3", align: "end" },
				{ text: "P4", value: "P4", align: "end" },
				{ text: "P5", value: "P5", align: "end" },
				{ text: "P6", value: "P6", align: "end" },
				// { text: "Dias sin facturar", value: "DiasSinFacturar", acceso: 'VER_FACTURAS_CONTRATOS' },
			].filter(header => !header.acceso || this.$root.acceso(header.acceso)).map((header) => {
				return {
					class: "text-no-wrap sticky-header",
					cellClass: "pa-2 text-no-wrap",
					filter: (value) => perColumnFilter(value, this.inlineFilters[header.value], header.dataType),
					dataType: "text",
					...header,
				};
			}),

			inlineFilters: {},
			comboboxes: {},
			loadingPDF: null,
			gettingCert: null,
			reenviandoSMS: false,
			documentacionModal: null,
			generandoPDF: null,
		};
	},
	computed: {
		contratosFiltrados() {
			return this.verAnulados
				? this.contratos
				: this.contratos.filter((c) => c.Situacion != "Anulado");
		},
	},
	methods: {
		getSituacionIcon,
		parseDate,
		getContratos() {
			this.loading = true;
			this.selected = [];
			let str = this.$store.getters.getDatosEmpresa;

			const { IdUsuario, IdAgente } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;

			axios({
				method: "GET",
				url: `${process.env.VUE_APP_OUR_API_URL}/contratosVerificados.php`,
				params: {
					token: this.$store.getters.getJwtEmpresa,
					IdAgente,
					codigoContrato: this.codigoContrato,
				},
			}).then((res) => {
				this.contratos = res.data.map((c) => ({
					...c,
					Denominacion:
						c.Denominacion ||
						c.RazonSocialTitular ||
						[c.NombreTitular, c.Apellido1Titular, c.Apellido2Titular]
							.filter((i) => !!i)
							.join(" "),
					DireccionCUPS:
						c.DireccionCUPS ||
						[c.CiudadSuministro, c.CallePuntoSuministro, c.Numero]
							.filter((i) => !!i)
							.join(", "),
					ConsumoEstimado: parseFloat(c.ConsumoEstimado).toFixed(3) * 1,
					P1: parseFloat(c.P1).toFixed(3) * 1 || null,
					P2: parseFloat(c.P2).toFixed(3) * 1 || null,
					P3: parseFloat(c.P3).toFixed(3) * 1 || null,
					P4: parseFloat(c.P4).toFixed(3) * 1 || null,
					P5: parseFloat(c.P5).toFixed(3) * 1 || null,
					P6: parseFloat(c.P6).toFixed(3) * 1 || null,
				}));
				this.loading = false;
			});
		},
		getContratosProximaRenovacion() {
			let str = this.$store.getters.getDatosEmpresa;

			const { IdUsuario, IdAgente } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;
			axios({
				method: "GET",
				url: `${process.env.VUE_APP_API_URL
					}/RenovacionContrato/ContratosProximosRenovacion/?Contratacion_FinderFilterRenovacionContratoAPIDTO={"IdEmpresa":${IdEmpresa},"IdUsuario":${IdUsuario},"IdAgente":${IdAgente},
					"DesdeFechaVTO" : ${new Date()},
					"HastaFechaVTO" : ${new Date()},
					"PaginationCount" : 200,
					"PaginationSkip" : 0,
					}`,
			})
				.then((res) => {
					// console.log(processToken(res.data));
				})
				.catch((err) => {
					console.error(err);
					this.$root.$emit("snack", "Ha ocurrido un error");
				});
		},
		verCondicionesContractuales(id) {
			this.loadingPDF = id;
			let str = this.$store.getters.getDatosEmpresa;
			const { IdUsuario } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;
			axios({
				method: "get",
				url: `${process.env.VUE_APP_API_URL}/Contrato/ContratoPreviewPDF/Empresa/${IdEmpresa}/Usuario/${IdUsuario}/Contrato/${id}`,
				responseType: "blob",
			})
				.then((res) => {
					let pdf = new File(
						[res.data],
						`contrato_${new Date().getTime()}.pdf`,
						{
							type: "application/pdf",
						}
					);
					downloadFile(pdf, true);
				})
				.catch((err) => {
					this.$root.$emit("snack", "Ha ocurrido un error");
				})
				.finally(() => {
					this.loadingPDF = null;
				});
		},
		comprobarDiasFacturacion(dias, estado) {
			if (dias < 30) return { texto: dias };
			if (estado == 'Activado') return { texto: dias + ' - Hacer estimada', color: 'warning' }
			if (estado == 'Trámite') return { texto: dias + ' - Demasiado tiempo en trámite', color: 'info' }
			return {};
		},
		verEvidenciaFirma(codContrato) {
			this.gettingCert = codContrato;
			axios({
				url: `${process.env.VUE_APP_OUR_API_URL}/certificado_firma.php`,
				method: "GET",
				params: {
					token: this.$store.getters.getJwtEmpresa,
					codigoContrato: codContrato,
				},
				responseType: "arraybuffer",
			})
				.then(({ data }) => {
					let decoder = new TextDecoder();
					if (
						/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
							decoder.decode(data)
						)
					) {
						let a = document.createElement("a");
						a.href = decoder.decode(data);
						a.click();
					} else {
						let file = new File(
							[data],
							`certificado_firma_${codContrato}.pdf`,
							{
								type: "application/pdf",
							}
						);

						downloadFile(file, true);
					}
				})
				.catch((e) => {
					if (e.response.status == 401) {
						this.documentacionModal = codContrato;
					} else {
						this.$root.$emit(
							"snack",
							"No se ha podido recuperar el certificado"
						);
					}
					this.gettingCert = null;
					return;
				})
				.finally(() => {
					this.gettingCert = null;
				});
		},
		async reenviarFirmaSMS({ CodigoContrato }) {
			if (
				!confirm(
					`¿Estás seguro de que quieres reenviar la firma del contrato ${CodigoContrato}?, se enviará como contrato de ${this.$store.getters.getNombreEmpresa.toUpperCase()}`
				)
			)
				return;
			this.reenviandoSMS = CodigoContrato;

			try {
				await axios({
					method: "GET",
					url: `${process.env.VUE_APP_OUR_API_URL}/enviar_firma_sms.php`,
					params: {
						codigoContrato: CodigoContrato,
						empresa: this.$store.getters.getNombreEmpresa,
						idContrato: CodigoContrato,
						token: this.$store.getters.getJwtEmpresa,
					},
				});
				this.$root.$emit("snack", "Se ha enviado el SMS de verificación");
			} catch (e) {
				console.error(e);
				this.$root.$emit(
					"snack",
					"No se ha podido enviar el SMS de verificación"
				);
			}

			this.reenviandoSMS = null;
		},
		async enviarFirmaEmail({ CodigoContrato }) {
			if (
				!confirm(
					`¿Estás seguro de que quieres iniciar la firma email del contrato ${CodigoContrato}?, se enviará como contrato de ${this.$store.getters.getNombreEmpresa.toUpperCase()}`
				)
			)
				return;
			this.reenviandoSMS = CodigoContrato;

			try {
				let { data: email_firma } = await axios({
					method: "GET",
					url: `https://pruebas.alumbraenergia.es/api/public/enviar_firma_email.php`,
					params: {
						codigoContrato: CodigoContrato,
						empresa: this.$store.getters.getNombreEmpresa,
						idContrato: CodigoContrato,
						token: this.$store.getters.getJwtEmpresa,
					},
				});
				this.$root.$emit("snack", "Se ha iniciado la firma email");
			} catch (e) {
				console.error(e);
				this.$root.$emit("snack", "No se ha podido enviar el email de firma");
			}
			this.reenviandoSMS = null;
		},
		async recordatorioEmail({ CodigoContrato }) {
			if (
				!confirm(
					`¿Estás seguro de que quieres enviar un recordatorio al contrato ${CodigoContrato}?`
				)
			)
				return;

			try {
				let { data: respuesta } = await axios({
					method: "GET",
					url: `${process.env.VUE_APP_OUR_API_URL}/recordatorio_email.php`,
					params: {
						idContrato: CodigoContrato,
						token: this.$store.getters.getJwtEmpresa,
					},
				});
				if (respuesta.code != 200) throw respuesta.code;
				this.$root.$emit("snack", "Se ha enviado el recordatorio de firma");
			} catch {
				this.$root.$emit(
					"snack",
					"No se ha podido enviar el recordatorio de firma"
				);
			}

			this.reenviandoSMS = null;
		},
		exportarTodos() {
			const getDatatype = (key) =>
				(this.contratosHeader.find((h) => h.value == key) || {}).dataType;

			this.selected = this.contratosFiltrados.filter((con) =>
				Object.entries(con).every(([key, value]) =>
					perColumnFilter(value, this.inlineFilters[key], getDatatype(key))
				)
			);

			this.$nextTick(() => {
				this.$refs.descargarBtn.$el.click();
				this.selected = [];
			});
		},
		generarPDF({ CodigoContrato }) {
			this.generandoPDF = CodigoContrato;
			axios({
				method: "get",
				url: `${process.env.VUE_APP_OUR_API_URL}/generar_pdf.php`,
				params: {
					codigoContrato: CodigoContrato,
					empresa: this.$store.getters.getNombreEmpresa,
					// empresa: this.contratos.find((c) => c.id == this.imprimirId).empresa,
					token: this.$store.getters.getJwtEmpresa,
					// firma : firma || null
				},
				headers: { "Access-Control-Allow-Origin": location.origin },
				responseType: "blob",
			})
				.then((res) => {
					let pdf = new File(
						[res.data],
						`borrador_${new Date().getTime()}.pdf`,
						{ type: "application/pdf" }
					);
					downloadFile(pdf, true);
					this.generandoPDF = null;
				})
				.catch((err) => {
					console.error(err);
					this.generandoPDF = null;
					this.$root.$emit("snack", "Ha ocurrido un error");
				});
		},
		copiarTexto(value) {
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.value = value
			input.select()
			try {
				document.execCommand('copy');
				this.$root.$emit('snack', 'Copiado al portapapeles')
			} catch {
			}
			input.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
			document.body.removeChild(input)
		}
	},
	mounted() {
		this.getContratos();
	},
};
</script>

<style scoped>
.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}
</style>